import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { ReportsService } from "./reports.service";
import { UnusualMile, UninvoicedDrawing, CardMisusage, AutomatedDrawing, UninvoicedDrawing2 } from "./reports";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { LoaderService } from "../LoaderService";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
declare var $: any;

@Component({
  templateUrl: "./reportdetail.component.html"
})
export class ReportDetailComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();

  public pageTitle: string = 'Reports';
  public reportName: string = '';
  public activeAccountId: string = '';
  public accessAccounts: IAccount[];
  public processAccount: IAccount;
  public unusualMiles: UnusualMile[];
  public uninvoicedDrawings: UninvoicedDrawing[];
  public cardMisusages: CardMisusage[];
  public automatedDrawings: AutomatedDrawing[];
  public includeNonFuel: string = "false";
  public includePrice: string = "true";
  //public startDate: Date;
  public startDate: Date;
  public lastRunDate: string;
  public showdistributiondd: boolean = false;
  public showAccountMultiselect: boolean = false;
  public RegisterCompanyUser: string = 'register';
  distributionData: any = [];
  public enableReport: string = "true";
  public accounts: IAccount[];
  public uninvoicedDrawing: UninvoicedDrawing2 = new UninvoicedDrawing2();
  public DrawingReportUsers: any = [];
  public ReportCompanyDetails: any;
  public RegisteredUserId: any;
  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public reportsService: ReportsService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.route.params.subscribe(params => {
      this.reportName = params['name'];
      this.accessAccounts = this.authService.getSelectedAccessAccounts();
      this.accounts = this.accessAccounts;
      this.accounts.forEach(x => {
        x.selected = false;
      });

      this.processAccount = null;
      this.processAccount = this.accessAccounts[0];
      this.onReportNameMatchInit();

      // this.LoadDrawingReportUsersByUserId();
      this.LoadDrawingReportUsers();
    });
  }

  onReportNameMatchInit() {
    this.loaderService.display(true);

    if (this.reportName == 'unusualmileage') {
      this.unusualMileageOnInit();
    }
    //else if (this.reportName == 'uninvoiceddrawings') {
    //  this.uninvoicedDrawingsOnInit();
    //}
    else if (this.reportName == 'uninvoiceddrawings2') {
      this.uninvoicedDrawingsOnInit();

    }
    else if (this.reportName == 'cardmisusage') {
      this.cardMisusageOnInit();
    }
    else if (this.reportName == 'automateddrawingreports') {
      this.automatedDrawingReportsOnInit();
    }
  }

  unusualMileageOnInit(): void {
    this.reportsService.getUnusualMileageByAccountId(this.processAccount.id)
      .subscribe(
        (unusualMile: UnusualMile) => {
          unusualMile.accountNumber = this.processAccount.name;
          unusualMile.ledger = this.processAccount.ledger;
          this.unusualMiles = [];
          this.unusualMiles.push(unusualMile);
          this.activeAccountId = this.processAccount.id;
          this.loaderService.display(false);
        },
        (error: any) => {
          this.loaderService.display(false);
          this.reportsService.showError("Unusual Mileage retrieval problem", <any>error);
        }
      );
  }

  onUnusualMileSubmit(unusualMile: UnusualMile): void {
    this.loaderService.display(true);
    this.reportsService.saveUnusualMileage(unusualMile, this.processAccount.id)
      .subscribe(
        (unusualMile: UnusualMile) => {
          this.loaderService.display(false);
          this.reportsService.showSuccess("Unusual Mileage", "info updated successfully.");
        },
        (error: any) => {
          this.loaderService.display(false);
          this.reportsService.showError("Unusual Mileage update problem", <any>error);
        }
      );
  }

  uninvoicedDrawingsOnInit(): void {
    this.reportsService.getUninvoicedDrawingByAccountId(this.processAccount.id)
      .subscribe(
        (uninvoicedDrawing: UninvoicedDrawing) => {
          uninvoicedDrawing.accountNumber = this.processAccount.name;
          uninvoicedDrawing.ledger = this.processAccount.ledger;
          this.uninvoicedDrawings = [];
          var date = uninvoicedDrawing.startDate.toString();
          //debugger
          if (date.indexOf("9999") != -1) {
            this.startDate = new Date();
          }
          else {
            var date1 = new Date(uninvoicedDrawing.startDate);
            this.startDate = new Date(date1);
          }
          this.uninvoicedDrawings.push(uninvoicedDrawing);
          this.activeAccountId = this.processAccount.id;
          this.LoadDrawingReportCompanyByAcId();
          this.loaderService.display(false);
        },
        (error: any) => {
          this.loaderService.display(false);
          this.reportsService.showError("Uninvoiced Drawing retrieval problem", <any>error);
        }
      );
  }

  onUninvoicedDrawingSubmit(uninvoicedDrawing: UninvoicedDrawing): void {
    this.loaderService.display(true);
    uninvoicedDrawing.startDate = this.convert(this.startDate);
    this.reportsService.saveUninvoicedDrawing(uninvoicedDrawing, this.processAccount.id)
      .subscribe(
        (uninvoicedDrawing: UninvoicedDrawing) => {
          this.loaderService.display(false);
          this.reportsService.showSuccess("Uninvoiced Drawing", "info updated successfully.");
        },
        (error: any) => {
          this.loaderService.display(false);
          this.reportsService.showError("Uninvoiced Drawing update problem", <any>error);
        }
      );
  }




  LoadDrawingReportCompanyByAcId() {
    let user = this.authService.getUser();
    this.reportsService.LoadDrawingReportCompanyByAcId(user.companyId)
      .subscribe(
        (data: any) => {
          let objData = JSON.parse(data._body);
          if (objData != undefined || objData != null) {

            this.includeNonFuel = objData.IncludeNonFuel.toString();
            this.includePrice = objData.IncludeEstimatedPrice.toString();
            this.enableReport = objData.IsEnabled.toString();
            //this.DrawingReportUsers=null;
            var date = new Date(Date.parse(objData.UnInvoicedReportLastDate));
            if (date.toString().indexOf("9999") != -1 || objData.UnInvoicedReportLastDate == null) {
              this.startDate = new Date();
            }
            else {
              this.startDate = date;
            }
          }
          else {
            this.startDate = new Date();
          }
        },
        (error: any) => {

        }
      );
  }


  DeleteRegisteredUser(id) {
    this.reportsService.DeleteRegisteredUser(id)
      .subscribe(
        (data: any) => {
          this.reportsService.showSuccess("Deleted User", "User Deleted successfully.");
          this.LoadDrawingReportUsers();
        },
        (error: any) => {

        }
      );
  }

  LoadDrawingReportUsersByUserId(id) {

    this.RegisteredUserId = id;
    this.reportsService.LoadDrawingReportUsersByUserId(id)
      .subscribe(
        (data: any) => {
          this.accounts.map(x => {
            x.selected = false;
          })
          let objData = JSON.parse(data._body);
          console.log(objData)
          this.enableReport = objData.IsUnInvoicedDrawingsEnabled.toString();
          this.uninvoicedDrawing = objData;
          this.uninvoicedDrawing.email = objData.Email;
          // if (this.enableReport !== "false") {
          this.showAccountMultiselect = false;
          if (objData.ReportOption === 2) {
            this.showAccountMultiselect = true;
          }
          this.accounts.map(x => {
            objData.AccountOpids.map(y => {
              if (x.id === y) {
                x.selected = true;
              }
            })
          })
          //}
        },
        (error: any) => {

        }
      );
  }

  LoadDrawingReportUsers() {
    this.dtOptions = {
      dom: '<"top"fip<"clear">>rt<"bottom"ip<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 15,
      order: [],
      //columnDefs: [{ width: 32, targets: 0 }, { orderable: false, targets: [0, 3] }, { bSearchable: false, targets: [0, 3] }, { type: 'date-uk', targets: [4] }],
      columnDefs: [{ width: 32, targets: 0 }, { bSearchable: false, targets: [0, 4] }],
      fixedColumns: true,
      buttons: [{}]
    }

    let user = this.authService.getUser();
    this.reportsService.LoadDrawingReportCompanyUsers(user.companyId)
      .subscribe(
        (data: any) => {
          this.DrawingReportUsers = JSON.parse(data._body);
          this.DrawingReportUsers.map(x => {
            x.accounts = null;
            x.AccountOpids.map(y => {
              this.accessAccounts.map(z => {
                if (y == z.id) {
                  x.accounts = z.name + "," + x.accounts
                  x.accounts = x.accounts.replace(',null', '')
                }
              })
            })

          })
          console.log(this.DrawingReportUsers);
        },
        (error: any) => {

        }
      );
  }


  onUninvoicedDrawingSubmit2(uninvoicedDrawing: UninvoicedDrawing2): void {
    if (uninvoicedDrawing.FirstName == undefined || uninvoicedDrawing.email == undefined ||
      uninvoicedDrawing.FirstName == '' || uninvoicedDrawing.email == '') {
      this.reportsService.showError("Register User", "FirstName / email cannot be null.");
      return;
    }
    //for updating registered user we are deleting old record and insert again
    if (this.RegisteredUserId != undefined || this.RegisteredUserId != null) {
      this.reportsService.DeleteRegisteredUser(this.RegisteredUserId)
        .subscribe(
          (data: any) => {
            console.log("user deleted ")
          },
          (error: any) => {

          }
        );
    }


    if (this.enableReport == "true") {
      if (uninvoicedDrawing.ReportOption == 2) {

        let accountSeletected = this.accounts.filter((x, i) => { return x.selected; }).length;
        if (accountSeletected != 0) {

          let user = this.authService.getUser();
          uninvoicedDrawing.startDate = this.convert(this.startDate);
          let RegisterCompany = { acid: "", historicalDate: "", includeNonFuel: false, includePrice: true, CompanyExportType: 1 };
          RegisterCompany.acid = user.companyId;//uninvoicedDrawing.accountId;
          RegisterCompany.historicalDate = uninvoicedDrawing.startDate;
          RegisterCompany.includeNonFuel = Boolean(JSON.parse(this.includeNonFuel));
          RegisterCompany.includePrice = Boolean(JSON.parse(this.includePrice));

          if (uninvoicedDrawing.ReportOption.toString() != "3") {
            uninvoicedDrawing.DistributionChannel = null;
          }
          this.reportsService.saveUninvoicedDrawingRegisterCompany(RegisterCompany, RegisterCompany.acid)
            .subscribe(
              (uninvoicedDrawingnew: any) => {
                //debugger
                this.LoadDrawingReportCompanyByAcId();
                this.loaderService.display(false);
                this.reportsService.showSuccess("Company Registered", "info created successfully.");
                let selectedAccounts = this.accounts.filter((x, i) => { return x.selected; });
                let selectedAccountIds = [];
                selectedAccounts.map(x => {
                  selectedAccountIds.push(x.id);
                })
                let RegisterCompanyUser = {
                  AcId: "", Email: "", FirstName: "", LastName: "", EmailReportOption: 0,
                  DistributionChannel: 0, AccountOpIds: []
                };

                RegisterCompanyUser.AcId = user.companyId;
                RegisterCompanyUser.Email = uninvoicedDrawing.email;
                RegisterCompanyUser.FirstName = uninvoicedDrawing.FirstName;
                RegisterCompanyUser.LastName = uninvoicedDrawing.LastName;
                RegisterCompanyUser.EmailReportOption = parseInt(uninvoicedDrawing.ReportOption.toString());
                RegisterCompanyUser.AccountOpIds = selectedAccountIds; //uninvoicedDrawing.accountId;
                RegisterCompanyUser.DistributionChannel = uninvoicedDrawing.DistributionChannel != null ? parseInt(uninvoicedDrawing.DistributionChannel.toString()) : 0;
                this.reportsService.saveUninvoicedDrawingRegisterCompanyUser(RegisterCompanyUser)
                  .subscribe(
                    (companyUser: any) => {
                      this.loaderService.display(false);
                      this.LoadDrawingReportUsers();
                      this.clearFields();
                      this.reportsService.showSuccess("Company Registered User", "info created successfully.");
                    },
                    (error: any) => {
                      this.loaderService.display(false);
                      this.clearFields();
                      this.reportsService.showError("Company Registered User create problem", <any>error);
                    }
                  );
                //  this.accounts.forEach(x => {
                //    if (x.selected) {
                //      this.loaderService.display(false);
                //      this.reportsService.showSuccess("Company Registered", "info created successfully.");
                //      let RegisterCompanyUser = { AcId: "", Email: "", FirstName: "", LastName: "", ReportOption: 0,
                //       DistributionChannel: null, AccountOpId: "" };
                //      RegisterCompanyUser.AcId = user.companyId;
                //      RegisterCompanyUser.Email = uninvoicedDrawing.email;
                //      RegisterCompanyUser.FirstName = uninvoicedDrawing.FirstName;
                //      RegisterCompanyUser.LastName = uninvoicedDrawing.LastName;
                //      RegisterCompanyUser.ReportOption = parseInt(uninvoicedDrawing.ReportOption.toString());
                //      RegisterCompanyUser.AccountOpId = x.id //uninvoicedDrawing.accountId;
                //      RegisterCompanyUser.DistributionChannel = uninvoicedDrawing.DistributionChannel != null ? parseInt(uninvoicedDrawing.DistributionChannel.toString()) : null;
                //      this.reportsService.saveUninvoicedDrawingRegisterCompanyUser(RegisterCompanyUser)
                //        .subscribe(
                //          (companyUser: any) => {
                //            this.loaderService.display(false);
                //            this.LoadDrawingReportUsers();
                //            this.reportsService.showSuccess("Company Registered User", "info created successfully.");
                //          },
                //          (error: any) => {
                //            this.loaderService.display(false);
                //            this.reportsService.showError("Company Registered User create problem", <any>error);
                //          }
                //        );

                //    }
                //  })
              },
              (error: any) => {
                this.loaderService.display(false);
                this.reportsService.showError("Company Registered create problem", <any>error);
              }
            );
          this.includeNonFuel = "false";
          this.includePrice = "true";
        }
        else {
          this.reportsService.showError("Account", "Select atleast one account.");
        }

      }
      else {
        //debugger
        let user = this.authService.getUser();
        uninvoicedDrawing.startDate = this.convert(this.startDate);
        let RegisterCompany = { acid: "", historicalDate: "", includeNonFuel: false, includePrice: true, CompanyExportType: 1 };
        RegisterCompany.acid = user.companyId;//uninvoicedDrawing.accountId;
        RegisterCompany.historicalDate = uninvoicedDrawing.startDate;
        RegisterCompany.includeNonFuel = Boolean(JSON.parse(this.includeNonFuel));
        RegisterCompany.includePrice = Boolean(JSON.parse(this.includePrice));

        if (uninvoicedDrawing.ReportOption.toString() != "3") {
          uninvoicedDrawing.DistributionChannel = null;
        }
        this.reportsService.saveUninvoicedDrawingRegisterCompany(RegisterCompany, RegisterCompany.acid)
          .subscribe(
            (uninvoicedDrawingnew: any) => {
              this.reportsService.showSuccess("Company Registered", "info created successfully.");

              let selectedAccountIds = [];
              this.accounts.map(x => {
                selectedAccountIds.push(x.id);
              })
              let RegisterCompanyUser = {
                AcId: "", Email: "", FirstName: "", LastName: "", EmailReportOption: 0,
                DistributionChannel: null, AccountOpIds: []
              };
              RegisterCompanyUser.AcId = user.companyId;
              RegisterCompanyUser.Email = uninvoicedDrawing.email;
              RegisterCompanyUser.FirstName = uninvoicedDrawing.FirstName;
              RegisterCompanyUser.LastName = uninvoicedDrawing.LastName;
              RegisterCompanyUser.EmailReportOption = parseInt(uninvoicedDrawing.ReportOption.toString());
              RegisterCompanyUser.AccountOpIds = selectedAccountIds; //uninvoicedDrawing.accountId;
              RegisterCompanyUser.DistributionChannel = uninvoicedDrawing.DistributionChannel != null ? parseInt(uninvoicedDrawing.DistributionChannel.toString()) : null;
              this.reportsService.saveUninvoicedDrawingRegisterCompanyUser(RegisterCompanyUser)
                .subscribe(
                  (companyUser: any) => {

                    this.loaderService.display(false);
                    this.LoadDrawingReportUsers();
                    this.reportsService.showSuccess("Company Registered User", "info created successfully.");
                    this.LoadDrawingReportCompanyByAcId();
                    this.clearFields();
                  },
                  (error: any) => {
                    this.clearFields();
                    this.loaderService.display(false);
                    this.reportsService.showError("Company Registered User create problem", <any>error);
                  }
                );
              // this.accessAccounts.forEach(x => {
              //   this.loaderService.display(false);
              //   this.reportsService.showSuccess("Company Registered", "info created successfully.");
              //   let RegisterCompanyUser = { AcId: "", Email: "", FirstName: "", LastName: "", ReportOption: 0, DistributionChannel: null, AccountOpId: "" };
              //   RegisterCompanyUser.AcId = user.companyId;
              //   RegisterCompanyUser.Email = uninvoicedDrawing.email;
              //   RegisterCompanyUser.FirstName = uninvoicedDrawing.FirstName;
              //   RegisterCompanyUser.LastName = uninvoicedDrawing.LastName;
              //   RegisterCompanyUser.ReportOption = parseInt(uninvoicedDrawing.ReportOption.toString());
              //   RegisterCompanyUser.AccountOpId = x.id; //uninvoicedDrawing.accountId;
              //   RegisterCompanyUser.DistributionChannel = uninvoicedDrawing.DistributionChannel != null ? parseInt(uninvoicedDrawing.DistributionChannel.toString()) : null;
              //   this.reportsService.saveUninvoicedDrawingRegisterCompanyUser(RegisterCompanyUser)
              //     .subscribe(
              //       (companyUser: any) => {
              //         this.loaderService.display(false);
              //         this.reportsService.showSuccess("Company Registered User", "info created successfully.");
              //       },
              //       (error: any) => {
              //         this.loaderService.display(false);
              //         this.reportsService.showError("Company Registered User create problem", <any>error);
              //       }
              //     );
              // })
            },
            (error: any) => {
              this.loaderService.display(false);
              this.reportsService.showError("Company Registered create problem", <any>error);
            }
          );
        this.includeNonFuel = "false";
        this.includePrice = "true";
      }

    }
    else {
      let user = this.authService.getUser();
      let acid = user.companyId
      this.reportsService.unRegisterCompany(acid)
        .subscribe(
          (response: any) => {
            this.reportsService.showSuccess("Company Un-Registration successfull", "info created successfully.");
            this.LoadDrawingReportCompanyByAcId();
            this.clearFields();
            // let unRegisterCompanyUser = { AcId: "", Email: "" };
            // unRegisterCompanyUser.AcId = user.companyId;
            // unRegisterCompanyUser.Email = uninvoicedDrawing.email;
            // this.reportsService.unRegisterCompanyUser(unRegisterCompanyUser)
            //   .subscribe(
            //     (companyUser: any) => {
            //       this.loaderService.display(false);
            //       this.LoadDrawingReportUsers();
            //       this.reportsService.showSuccess("Company Un-Registration User successfull", "info created successfully.");
            //     },
            //     (error: any) => {
            //       this.loaderService.display(false);
            //       this.reportsService.showError("Company Un-Registration User problem", <any>error);
            //     }
            //   );
          },
          (error: any) => {
            this.loaderService.display(false);
            this.reportsService.showError("Error while Un-Registering company", <any>error);
          }
        );
    }


  }

  clearFields() {
    this.RegisteredUserId = undefined;
    this.uninvoicedDrawing.FirstName = '';
    this.uninvoicedDrawing.email = '';
    this.uninvoicedDrawing.LastName = '';
    this.accounts.map(x => {
      x.selected = false;
    })
  }

  cardMisusageOnInit(): void {
    this.reportsService.getCardMisusageByAccountId(this.processAccount.id)
      .subscribe(
        (cardMisusage: CardMisusage) => {
          cardMisusage.accountNumber = this.processAccount.name;
          cardMisusage.ledger = this.processAccount.ledger;
          this.cardMisusages = [];
          this.cardMisusages.push(cardMisusage);
          this.activeAccountId = this.processAccount.id;
          this.loaderService.display(false);
        },
        (error: any) => {
          this.loaderService.display(false);
          this.reportsService.showError("Card Misusage retrieval problem", <any>error);
        }
      );
  }

  onCardMisusageSubmit(cardMisusage: CardMisusage): void {
    this.loaderService.display(true);
    this.reportsService.saveCardMisusage(cardMisusage, this.processAccount.id)
      .subscribe(
        (cardMisusage: CardMisusage) => {
          this.loaderService.display(false);
          this.reportsService.showSuccess("Card Misusage", "info updated successfully.");
        },
        (error: any) => {
          this.loaderService.display(false);
          this.reportsService.showError("Card Misusage update problem", <any>error);
        }
      );
  }

  automatedDrawingReportsOnInit(): void {
    this.reportsService.getAutomatedDrawingByAccountId(this.processAccount.id)
      .subscribe(
        (automatedDrawing: AutomatedDrawing) => {
          automatedDrawing.accountNumber = this.processAccount.name;
          automatedDrawing.ledger = this.processAccount.ledger;
          this.automatedDrawings = [];
          var date = automatedDrawing.lastRunDate.toString();
          if (date.indexOf("0001") != -1) {

            //var date1 = date.toUTCString();
            automatedDrawing.lastRunDate = this.reFormatDate(new Date());
            this.lastRunDate = this.formatDate(new Date());
          }
          else {
            var lrd = automatedDrawing.lastRunDate;
            this.lastRunDate = this.formatDate(new Date(lrd));
          }
          this.automatedDrawings.push(automatedDrawing);
          this.activeAccountId = this.processAccount.id;
          this.loaderService.display(false);
        },
        (error: any) => {
          this.loaderService.display(false);
          this.reportsService.showError("Automated Drawing retrieval problem", <any>error);
        }
      );
  }

  onAutomatedDrawingSubmit(automatedDrawing: AutomatedDrawing): void {
    this.loaderService.display(true);
    this.reportsService.saveAutomatedDrawing(automatedDrawing, this.processAccount.id)
      .subscribe(
        (automatedDrawing: AutomatedDrawing) => {
          this.loaderService.display(false);
          this.reportsService.showSuccess("Automated Drawing", "info updated successfully.");
        },
        (error: any) => {
          this.loaderService.display(false);
          this.reportsService.showError("Automated Drawing update problem", <any>error);
        }
      );
  }

  ngAfterViewInit(): void {

  }

  convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //date format
  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    ///return [year, month, day].join('-');
    return [day, month, year].join('/');
  }

  reFormatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  onAccountTabClick(index: number) {
    this.processAccount = this.accessAccounts[index];
    this.onReportNameMatchInit();
  }

  changereportoption(val: any) {
    if (val == "3") {
      this.distributionData = [];
      this.showdistributiondd = true;
      this.showAccountMultiselect = false;
      let distributionData = [
        { Text: 'Fuel Card Services', Value: '10' },
        { Text: 'FastFuel', Value: '11' },
        { Text: 'Diesel Direct', Value: '12' },
        { Text: 'UK Fuels', Value: '13' },
        { Text: 'MyFuel', Value: '14' },
        { Text: 'Shell', Value: '15' },
        { Text: 'BP', Value: '16' },
        { Text: 'Esso', Value: '17' },
        { Text: 'Allstar', Value: '18' },
        { Text: 'Allstar One', Value: '19' },
        { Text: 'BunkerStock', Value: '20' },
        { Text: 'MileageCount', Value: '21' },
        { Text: 'MyDriveSafe.Expert', Value: '22' },
        { Text: 'Tele-Gence', Value: '23' },
        { Text: 'MyService.Expert', Value: '24' },
        { Text: 'Bulk Deliveries', Value: '25' }
      ]

      this.accessAccounts.forEach(X => {
        distributionData.forEach(y => {
          if (X.product.toLowerCase() == y.Text.toLowerCase()) {
            this.distributionData.push(y);
          }
        })
      })

    } else {
      this.showAccountMultiselect = false;
      this.showdistributiondd = false;
      this.accounts.forEach(x => {
        x.selected = false;
      });
      if (val == '2') {
        this.showAccountMultiselect = true;
      }


    }

  }

  changeRegisterCompanyUser(val: any) {
    this.RegisterCompanyUser = val;
  }

  onItemChange(item: any) {
    this.enableReport = item;
  }

  selectAllAccountChange(e) {
    if (e.target.checked) {
      this.accounts.forEach(eachObj => {
        eachObj.selected = true;
      });
    }
    else {
      this.accounts.forEach(eachObj => {
        eachObj.selected = false;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/reportdetail.component.ts